export default __webpack_public_path__ + "static/media/skoki.af4fb59e.png";